import React, { useEffect, useRef, useState } from 'react';
import { UnorderedList, chakra, VStack } from '@chakra-ui/react';
import styled from '../../../consts/styled';
import { colors } from '../../../App/ChakraTheme';
import FormDataContext from '../context/formDataContext';

const DjangoForm = styled(({ className, children, ...props }) => {
  const formErrors = useRef<{ [key: string]: string[] }>({});
  const nonFieldErrors = useRef<string[]>([]);
  const formValues = useRef<{ [key: string]: string }>({});
  const [, setDummyState] = useState(false);

  useEffect(() => {
    const formErrorsData = document.getElementById('form_errors');
    const formValuesData = document.getElementById('form_values');
    formValues.current =
      formValuesData && formValuesData.textContent != null
        ? JSON.parse(formValuesData.textContent)
        : {};
    formErrors.current =
      formErrorsData && formErrorsData.textContent != null
        ? JSON.parse(formErrorsData.textContent)
        : {};
    nonFieldErrors.current = formErrors.current['__all__'] || [];
    // Trigger re-render
    setDummyState(prev => !prev);
  }, []);

  const formRef = useRef(null);

  return (
    <chakra.form ref={formRef} className={className} {...props}>
      <VStack spacing={0} gap={12} w="full">
        <UnorderedList className="cul">
          {nonFieldErrors.current.map((value, index) => (
            <li key={index}>{value}</li>
          ))}
        </UnorderedList>
        <FormDataContext.Provider
          value={{
            formValues: formValues.current,
            formErrors: formErrors.current,
          }}
        >
          {children}
        </FormDataContext.Provider>
      </VStack>
    </chakra.form>
  );
})`
  // TODO move this to inputText component
  .fieldError {
    display: block;
  }

  .cul {
    li {
      font-size: 14px;
      color: ${colors.crimson};
    }
  }
`;

export default DjangoForm;
